// extracted by mini-css-extract-plugin
export var drawerPaper = "_16-0";
export var itemCard = "_16-1";
export var itemImage = "_16-2";